export default {
  title: 'Verkkosivustosi on valmis',
  body_one: 'Varaukset ovat edelleen pois päältä {{count}} ravintolassa:',
  body_other: 'Varaukset ovat edelleen pois päältä {{count}} ravintolassa:',
  reasons: {
    license_required: 'Vaatii Partner-tilauksen',
    notification_email_required:
      'Vaatii sähköpostiosoitteen varausilmoituksia varten. Lisää se, kun otat varaukset käyttöön.',
    switched_off: 'Pois päältä varausasetuksissa',
    activation_failed: 'Käyttöönotto epäonnistui. Yritä uudelleen varausasetuksista.',
  },
  buttons: {
    open_settings: 'Avaa varausasetukset',
    continue: 'Jatka verkkosivustorakentajaan',
  },
};
